import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import VCalendar from 'v-calendar';
import i18n from './i18n';
import { createPinia } from 'pinia';
import Toaster from '@meforma/vue-toaster';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import MyGocuButton from './components/common/buttons/MyGocuButton.vue';
import { sanitizeHtml } from './directives/sanitizeHtml';
import { VueWhatsAppWidget } from '@greenborn/vue3-whatsapp-widget'
import HomeApiService from '@/services/api/skiandnight/HomeApiService';
import { agenciaStoreModule } from '@/store_pinia/agencia';
import { appGlobalStore } from '@/store_pinia/app';
import axios from 'axios';
import { addMetaPixel } from '@/services/utils/metaPixelUtils';
import { addGtagPixel } from '@/services/utils/gtagPixelUtils';

async function loadAgenciaConfig() {
  const agenciaStore = agenciaStoreModule();
  const storeGlobal = appGlobalStore();
  const res = await HomeApiService.getAgencia();
  agenciaStore.setData(res);
  storeGlobal.setValoresResources(res.recursos);
  const permisos = await axios.get(agenciaStore.getPermisos);
  storeGlobal.setPermisos(permisos.data);
  selectorIdiomas(res.recursos);
}

async function initHtml() {
  const agenciaStore = agenciaStoreModule();

  let file = document.createElement('link');
  let headTitle = document.querySelector('head');
  let setFavicon = document.createElement('link');

  document.title = agenciaStore.getMetaTitulo;

  var meta = document.createElement('meta');
  meta.name = 'description';
  meta.content = agenciaStore.getMetaDescripcion;
  document.getElementsByTagName('head')[0].appendChild(meta);

  file.rel = 'stylesheet';
  file.href = agenciaStore.getCss;
  document.head.appendChild(file);

  setFavicon.setAttribute('rel', 'shortcut icon');
  setFavicon.setAttribute('href', agenciaStore.getFavicon);
  headTitle.appendChild(setFavicon);

  if (agenciaStore.getMeta) {
    addMetaPixel(agenciaStore.getMeta);
  }
  if (agenciaStore.getGoogleAnalitycs) {
    addGtagPixel(agenciaStore.getGoogleAnalitycs);
  }
}

function selectorIdiomas(response) {
  const storeGlobal = appGlobalStore();
  axios.get(response.translations_en).then(res => {
    storeGlobal.setTranslations(res.data, 'en');
  });
  axios.get(response.translations_es).then(res => {
    storeGlobal.setTranslations(res.data, 'es');
  });
  axios.get(response.translations_fr).then(res => {
    storeGlobal.setTranslations(res.data, 'fr');
  });
  axios.get(response.translations_it).then(res => {
    storeGlobal.setTranslations(res.data, 'it');
  });
}

async function initApp() {
  const app = createApp(App)
    .use(i18n)
    .use(createPinia())
    .use(router)
    .use(VCalendar, {})
    .use(Toaster)
    .use(VueWhatsAppWidget)
    .component('mg-btn', MyGocuButton)
    .use(VueGoogleMaps, {
      load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
        language: 'es',
      },
    })
    .directive('sanitize-html', sanitizeHtml);

  await loadAgenciaConfig();
  await initHtml();

  // Place here any plugin that needs back information from the back-end

  app.mount('#app');
}

initApp();
